/**
 * Taken from in pdf.js/web/pdf_thumbnail_view.js TempImageFactory
 */
export class TempImageFactory {
  private static tempCanvas: HTMLCanvasElement | null = null;

  static getCanvas(width: number, height: number) {
    const tempCanvas = (this.tempCanvas ||= document.createElement('canvas'));
    tempCanvas.width = width;
    tempCanvas.height = height;

    // Since this is a temporary canvas, we need to fill it with a white
    // background ourselves. `#getPageDrawContext` uses CSS rules for this.
    const ctx = tempCanvas.getContext('2d', { alpha: false });
    if (!ctx) {
      return {
        canvas: null,
        context: null,
      };
    }

    ctx.save();
    ctx.fillStyle = 'rgb(255, 255, 255)';
    ctx.fillRect(0, 0, width, height);
    ctx.restore();
    return {
      canvas: tempCanvas,
      context: tempCanvas.getContext('2d'),
    };
  }

  static destroyCanvas() {
    const tempCanvas = this.tempCanvas;
    if (tempCanvas) {
      // Zeroing the width and height causes Firefox to release graphics
      // resources immediately, which can greatly reduce memory consumption.
      tempCanvas.width = 0;
      tempCanvas.height = 0;
    }
    this.tempCanvas = null;
  }
}
